export default {
    totalUniqueParts: 'Total Unique Parts',
    totalParts: 'Total Parts',
    totalRelevantParts: 'Total Licence Relevant Parts',
    partsQuota: 'Parts Quota',
    partsQuotaLeft: 'Remaining Parts Quota',
    uniqueParts: 'Unique Parts',
    used: 'Used',
    viewerLicenses: 'Viewer Licenses',
    editorLicenses: 'Editor Licenses',
    numberOfViewers: 'Number of Viewers',
    numberOfEditors: 'Number of Editors',
}